import {withStylesProvider} from '../../utils/withStylesProvider';

import {ListBullet} from './ListBullet';
import {ListItem, ListItemLabel, ListItemPercentage, ListItemValue} from './ListItem';
import {List as ListInternal} from './List';
import {StylesProvider} from './context';
import {widgetListTheme} from './theme/theme';

type ListType = typeof ListInternal & {
  Item: typeof ListItem;
  Bullet: typeof ListBullet;
  Value: typeof ListItemValue;
  Label: typeof ListItemLabel;
  Percentage: typeof ListItemPercentage;
};

const List = withStylesProvider(ListInternal, StylesProvider, widgetListTheme) as unknown as ListType;
List.Item = ListItem;
List.Bullet = ListBullet;
List.Value = ListItemValue;
List.Label = ListItemLabel;
List.Percentage = ListItemPercentage;

// We do names export as well as dot-notation since next.js RSC doesn't support dot-notation pattern.
export {List, ListItem};
export type {ListProps} from './List';
